import useCreate from "./hooks/useCreate";
import UISchemaJson from "./schema/UISchema.json";
import SchemaJson from "./schema/SchemaJson.json";
import { Sites } from "data/utils/globals";
import { SchemaData } from "./hooks/types";
import { CreateGql } from "./queries/create";
import { GenericMethods } from "layouts/aplicacoes/GenericMethods";
import { CreateProps } from "./types";

function Create(props: CreateProps) {
  return (
    <GenericMethods.Create<SchemaData, CreateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      useCreate={useCreate}
      template={{
        schemaJson: SchemaJson,
        UISchema: UISchemaJson,
      }}
      {...props}
    />
  );
}

export default Create;
